export const GET_TREE_ORG = "GET_TREE_ORG";
export const SET_TREE_ORG = "SET_TREE_ORG";
export const SET_SELECTED_ORG = "SET_SELECTED_ORG";
export const GET_DETAIL_ORG = "GET_DETAIL_ORG";
export const SET_DETAIL_ORG = "SET_DETAIL_ORG";
export const INSERT_ORG = "INSERT_ORG";
export const UPDATE_ORG = "UPDATE_ORG";
export const DELETE_ORG = "DELETE_ORG";
